import React, { useState } from "react";
import "./FilterComponent.css";
import { Accordion, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Tabs, Tab } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useDispatch, useSelector } from "react-redux";
import { setProductFilter } from "../../../features/products/productsSlice";

const FilterComponent = ({ extraFunction, concerns, category }) => {
  const dispatch = useDispatch();

  const filters = useSelector((state) => state.product.filters);

  const [activeKey, setActiveKey] = useState("0");
  const price = [filters.min_price, filters.max_price];
  const checkboxOptions = [
    "Immunity",
    "Fat-loss",
    "Face",
    "Skin",
    "Heart",
    "Blood",
  ];

  return (
    <section className="Filter_By">
      <div className="filter_section product-by-category">
        <p className="section_title">Subcategories</p>
        <div>
          {category?.length > 0 &&
            category?.map((cat, index) => {
              return (
                <Accordion
                  key={cat.id}
                  activeKey={activeKey}
                  onSelect={(e) => setActiveKey(e)}
                >
                  <Accordion.Item eventKey={String(index)}>
                    <Accordion.Header className="acc_header">
                      <p className="inner_text">{cat.name}</p>
                    </Accordion.Header>

                    <Accordion.Body>
                      {cat?.p_sub_categories?.length > 0 ? (
                        cat?.p_sub_categories.map((sub) => (
                          <Form.Check
                            key={sub.id}
                            type="checkbox"
                            label={sub.name}
                            className="custom_checkbox"
                            checked={(filters.subcategory_ids || []).includes(
                              sub.id,
                            )}
                            onChange={(e) => {
                              const currentIds = filters.subcategory_ids || [];

                              const updatedIds = e.target.checked
                                ? [...currentIds, sub.id]
                                : currentIds.filter((id) => id !== sub.id);

                              dispatch(
                                setProductFilter({
                                  page: 1,
                                  subcategory_ids: updatedIds,
                                }),
                              );
                            }}
                          />
                        ))
                      ) : (
                        <p className="list_text">No Data Found</p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              );
            })}
        </div>
      </div>

      {/* Products by Category */}
      <div className="filter_section product-by-category">
        <p className="section_title">Availability</p>
        <div className="all_checkbox">
          <Form.Check
            type="checkbox"
            label="In Stock"
            checked={filters.in_stock}
            onChange={(e) =>
              dispatch(
                setProductFilter({
                  in_stock: e.target.checked,
                  page: 1,
                }),
              )
            }
          />
          <Form.Check
            type="checkbox"
            label="Not Available"
            checked={filters.out_of_stock || false}
            onChange={(e) =>
              dispatch(
                setProductFilter({
                  out_of_stock: e.target.checked,
                  page: 1,
                }),
              )
            }
          />
        </div>
      </div>

      <div className="filter_section product-by-category">
        <p className="section_title">Price</p>
        <div className="price-range-wrapper">
          <div className="price-values">
            <span>₹{price[0]}</span>
            <span>₹{price[1]}</span>
          </div>

          <div className="slider">
            <ReactSlider
              className="price-slider"
              thumbClassName="price-thumb"
              trackClassName="price-track"
              value={price}
              min={0}
              max={filters.variant_max}
              step={25}
              onChange={(value) =>
                dispatch(
                  setProductFilter({
                    min_price: value[0],
                    max_price: value[1],
                    page: 1,
                  }),
                )
              }
            />
          </div>
        </div>
      </div>

      <div className="filter_section product-by-category">
        <p className="section_title">Medicine</p>
        <div className="all_checkbox">
          {concerns.map((item) => (
            <Form.Check
              key={item.id}
              type="checkbox"
              label={item.name}
              className="custom_checkbox"
              checked={filters.concerns.includes(item.id)}
              onChange={(e) => {
                const updatedConcerns = e.target.checked
                  ? [...filters.concerns, item.id]
                  : filters.concerns.filter((id) => id !== item.id);

                dispatch(
                  setProductFilter({
                    concerns: updatedConcerns,
                  }),
                );
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FilterComponent;
